/**
 * Shared TanStack Query option presets for web, portal-web, and mobile.
 * Apps may extend these in local `config/baseQueryOptions.ts` barrels.
 */
export const commonQueryOptions = {
  /** List queries (e.g. projects, tasks, contacts). Base preset — web adds refetchOnMount. */
  list: {
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  },

  /** Detail queries (single resource by id). */
  detail: {
    staleTime: 60_000,
    gcTime: 5 * 60 * 1000,
  },

  /** Frequently changing data (always refetch). */
  alwaysRefetch: {
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  },

  /** Stable data (5 minute stale time). */
  stable: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  },

  /** Very stable data (30 minute stale time). */
  veryStable: {
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  },
} as const;

export type CommonQueryPreset = keyof typeof commonQueryOptions;
